import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { StsUser } from '../models/sts-user.model';
import { StsHttpService } from './sts-http.service';

@Injectable()
export class StsUserService {

  constructor(private stsHttp: StsHttpService) {
  }

  public changeUserId(user: StsUser): Observable<any> {
    return this.stsHttp.post<any>('/api/users/my/rename', user);
  }

  public getPasswordPolicy(user: StsUser): Observable<any> {
    return this.stsHttp.get<any>('/api/users/my/passwordpolicy', user);
  }

  public getCommunicationChannels(): Observable<any> {
    return this.stsHttp.get<any>('/api/users/my/communicationChannels');
  }

  public getProfile(): Observable<any> {
    return this.stsHttp.get<any>('/api/users/my/profile');
  }

  public updateEmailAddress(user: StsUser): Observable<any> {
    return this.stsHttp.post<any>('/api/users/my/updateEmail', user);
  }
}
